import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/EN.json';
import translationFR from './locales/FR.json';
import translationES from './locales/ES.json';
import translationAR from './locales/AR.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationEN },
      fr: { translation: translationFR },
      es: { translation: translationES },
      ar: { translation: translationAR }
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
